import React from 'react';
import { Card, Row, Col, Statistic, Skeleton } from 'antd';
import { FileTextOutlined, SolutionOutlined, ContainerOutlined } from '@ant-design/icons';

const SystemTotals = ({ data, loading }) => {
  if (loading) {
    return <Skeleton active paragraph={{ rows: 3 }} />;
  }

  const {
    total_inspection_requests = 0,
    total_reports = 0,
    total_invoices = 0,
  } = data || {};

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} style={{ marginBottom: 12 }}>
        <Statistic
          title="Total Inspection Requests"
          value={total_inspection_requests}
          prefix={<SolutionOutlined />}
        />
      </Col>
      <Col span={24} style={{ marginBottom: 12 }}>
        <Statistic
          title="Total Reports"
          value={total_reports}
          prefix={<FileTextOutlined />}
        />
      </Col>
      <Col span={24}>
        <Statistic
          title="Total Invoices"
          value={total_invoices}
          prefix={<ContainerOutlined />}
        />
      </Col>
    </Row>
  );
};

export default SystemTotals;
